// Converts raw http(s)/www. URLs found in TEXT NODES of a comment's HTML
// into clickable <a> tags before it's passed through DOMPurify. Operates
// on the parsed DOM (not a regex over the raw HTML string) so block tags
// (<div>, <br>), entities (&nbsp;) and existing <a> links are never
// corrupted or double-wrapped — only plain text content is touched.
const URL_RE = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
const TRAILING_PUNCT = /[.,;:!?)\]}'"]+$/;

const linkifyTextNode = (textNode) => {
  const text = textNode.textContent;
  URL_RE.lastIndex = 0;
  if (!URL_RE.test(text)) return;
  URL_RE.lastIndex = 0;

  const frag = document.createDocumentFragment();
  let lastIndex = 0;
  let match;
  while ((match = URL_RE.exec(text)) !== null) {
    let url = match[0];
    let trail = '';
    const trailMatch = url.match(TRAILING_PUNCT);
    if (trailMatch) {
      trail = trailMatch[0];
      url = url.slice(0, url.length - trail.length);
    }
    if (!url) continue;
    frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
    const a = document.createElement('a');
    const href = url.toLowerCase().startsWith('www.') ? `https://${url}` : url;
    a.setAttribute('href', href);
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
    a.textContent = url;
    frag.appendChild(a);
    if (trail) frag.appendChild(document.createTextNode(trail));
    lastIndex = match.index + match[0].length;
  }
  frag.appendChild(document.createTextNode(text.slice(lastIndex)));
  textNode.parentNode.replaceChild(frag, textNode);
};

const walk = (node) => {
  if (node.nodeType === 1 && node.tagName === 'A') return; // never re-linkify inside an existing <a>
  Array.from(node.childNodes).forEach((child) => {
    if (child.nodeType === 3) {
      linkifyTextNode(child);
    } else if (child.nodeType === 1) {
      walk(child);
    }
  });
};

export const linkifyHtml = (html) => {
  if (!html || typeof document === 'undefined') return html;
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  walk(wrapper);
  return wrapper.innerHTML;
};
